module.exports = __webpack_public_path__ + "static/media/FM_PDS_September_2023-ASIC.410127a7.pdf";